import React, { Component } from "react";
import PropTypes from "prop-types";

import { Button, ButtonGroup } from "react-bootstrap";

import SportSolutionApiWrapper from "../utils/SportSolutionApiWrapper";

import "./CenterList.css";
class CenterList extends Component {
  constructor() {
    super();
    this.renderCenter = this.renderCenter.bind(this);
    this.getCenters = this.getCenters.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.state = {
      centers: [],
      selectedCenterId: null,
    };
  }

  componentWillMount() {
    // if (this.props.user && this.props.user.username) {
    this.getCenters();
    // }
  }

  getCenters() {
    let ssaw = new SportSolutionApiWrapper();
    let that = this;
    ssaw.centers(function(resp) {
      let centers = new Array();
      for (let center of resp.gyms) {
        centers.push({
          name: center.name,
          id: center.id,
        });
      }
      that.setState({
        centers: centers,
      });
      that.setCenter(centers[0].id);
      that.props.setCenters(centers);
    });
  }

  setCenter(center_id, event) {
    if (event) event.preventDefault();
    this.props.setCenter(center_id);
    this.setState({
      selectedCenterId: center_id,
    });
  }

  renderCenter(center) {
    return (
      <div key={center.id} className="center-list-element gym">
        <Button
          onClick={e => this.setCenter(center.id, e)}
          block
          bsSize="small"
          className={center.id == this.state.selectedCenterId ? "active" : ""}
        >
          {center.name}
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div className="gym-selector">
        <div className="gyms-wrapper">{this.state.centers.map(this.renderCenter)}</div>
      </div>
    );
  }
}

CenterList.propTypes = {
  user: PropTypes.object.isRequired,
};
export default CenterList;
